module.exports = __webpack_public_path__ + "img/2w.3e2132a1.svg";